import {
  AcademicCalendar,
  ResourceMaturity,
  ResourceVisibilityType,
  Weekday,
} from "@examspark/types";

export const sampleAcademicCalendar: AcademicCalendar = {
  id: "a18946e1-b46d-4f48-99ea-ccadcadb70d5",
  sk: "academic-calendar#v0",
  schemaVersion: "2020-01-01",
  workspaceId: "workspace-id",
  startAt: "2023-08-14Z",
  endAt: "2024-05-30Z",
  maturity: ResourceMaturity.Operational,
  bankId: "bank-id",
  name: "Sample Academic Calendar",
  visibility: ResourceVisibilityType.Workspace,
  instructionWeekdays: [
    Weekday.Monday,
    Weekday.Tuesday,
    Weekday.Wednesday,
    Weekday.Thursday,
    Weekday.Friday,
  ],
  gradingPeriodLength: "6_WEEKS",
  gradingPeriods: [
    {
      label: "1st 6 Weeks",
      startAt: "2023-08-14Z",
      endAt: "2023-09-22Z",
    },
    {
      label: "2nd 6 Weeks",
      startAt: "2023-09-25Z",
      endAt: "2023-11-03Z",
    },
    {
      label: "3rd 6 Weeks",
      startAt: "2023-11-06Z",
      endAt: "2023-12-21Z",
    },
    {
      label: "4th 6 Weeks",
      startAt: "2024-01-09Z",
      endAt: "2024-02-16Z",
    },
    {
      label: "5th 6 Weeks",
      startAt: "2024-02-20Z",
      endAt: "2024-04-12Z",
    },
    {
      label: "6th 6 Weeks",
      startAt: "2024-04-15Z",
      endAt: "2024-05-30Z",
    },
  ],
  nonInstructionDates: [
    {
      label: "Labor Day",
      type: "HOLIDAY",
      startAt: "2023-09-04Z",
    },
    {
      label: "Teacher Work Day",
      type: "TEACHER_WORKDAY",
      startAt: "2023-09-15Z",
    },
    {
      label: "Fall Break",
      type: "HOLIDAY",
      startAt: "2023-10-06Z",
      endAt: "2023-10-09Z",
    },
    {
      label: "Teacher Work Day",
      type: "TEACHER_WORKDAY",
      startAt: "2023-10-27Z",
    },
    {
      label: "Teacher Work Day",
      type: "TEACHER_WORKDAY",
      startAt: "2023-11-07Z",
    },
    {
      label: "Thanksgiving Break",
      type: "HOLIDAY",
      startAt: "2023-11-20Z",
      endAt: "2023-11-24Z",
    },
    {
      label: "Winter Break",
      type: "HOLIDAY",
      startAt: "2023-12-22Z",
      endAt: "2024-01-05Z",
    },
    {
      label: "Teacher Work Day",
      type: "TEACHER_WORKDAY",
      startAt: "2024-01-08Z",
    },
    {
      label: "Teacher Work Day",
      type: "TEACHER_WORKDAY",
      startAt: "2024-01-26Z",
    },
    {
      label: "Teacher Work Day",
      type: "TEACHER_WORKDAY",
      startAt: "2024-02-09Z",
    },
    {
      label: "President's Day",
      type: "HOLIDAY",
      startAt: "2024-02-19Z",
    },
    {
      label: "Spring Break",
      type: "HOLIDAY",
      startAt: "2024-03-11Z",
      endAt: "2024-03-15Z",
    },
    {
      label: "Teacher Work Day",
      type: "TEACHER_WORKDAY",
      startAt: "2024-03-28Z",
    },
    {
      label: "STAAR Testing (ELA)",
      type: "ASSESSMENT",
      startAt: "2024-04-15Z",
      endAt: "2024-04-17Z",
    },
    {
      label: "STAAR Testing (Science)",
      type: "ASSESSMENT",
      startAt: "2024-04-22Z",
      endAt: "2024-04-24Z",
    },
    {
      label: "STAAR Testing (Math)",
      type: "ASSESSMENT",
      startAt: "2024-05-06Z",
      endAt: "2024-05-08Z",
    },
  ],
};

/**
 * Source:
 * https://www.irvingisd.net/cms/lib/TX50000716/Centricity/Domain/4/20242025_Calendar_student.pdf
 */
export const sampleAcademicCalendar2425: AcademicCalendar = {
  id: "a18946e1-b46d-4f48-99ea-ccadcadb70d5",
  sk: "academic-calendar#v0",
  schemaVersion: "2020-01-01",
  workspaceId: "workspace-id",
  startAt: "2024-08-01Z",
  endAt: "2025-05-29Z",
  maturity: ResourceMaturity.Operational,
  bankId: "bank-id",
  name: "Sample Academic Calendar",
  visibility: ResourceVisibilityType.Workspace,
  instructionWeekdays: [
    Weekday.Monday,
    Weekday.Tuesday,
    Weekday.Wednesday,
    Weekday.Thursday,
    Weekday.Friday,
  ],
  gradingPeriodLength: "6_WEEKS",
  gradingPeriods: [
    {
      label: "1st 6 Weeks",
      startAt: "2024-08-12Z",
      endAt: "2024-09-20Z",
    },
    {
      label: "2nd 6 Weeks",
      startAt: "2024-09-23Z",
      endAt: "2024-11-01Z",
    },
    {
      label: "3rd 6 Weeks",
      startAt: "2024-11-04Z",
      endAt: "2024-12-20Z",
    },
    {
      label: "4th 6 Weeks",
      startAt: "2025-01-07Z",
      endAt: "2025-02-14Z",
    },
    {
      label: "5th 6 Weeks",
      startAt: "2025-02-18Z",
      endAt: "2025-04-11Z",
    },
    {
      label: "6th 6 Weeks",
      startAt: "2025-04-14Z",
      endAt: "2025-05-29Z",
    },
  ],
  nonInstructionDates: [
    {
      label: "Teacher Work Day",
      type: "TEACHER_WORKDAY",
      startAt: "2024-08-01Z",
      endAt: "2024-08-02Z",
    },
    {
      label: "Holiday",
      type: "HOLIDAY",
      startAt: "2024-08-05Z",
    },
    {
      label: "Teacher Work Day",
      type: "TEACHER_WORKDAY",
      startAt: "2024-08-06Z",
      endAt: "2024-08-09Z",
    },
    {
      label: "Labor Day",
      type: "HOLIDAY",
      startAt: "2024-09-02Z",
    },
    {
      label: "Teacher Work Day",
      type: "TEACHER_WORKDAY",
      startAt: "2024-09-13Z",
    },
    {
      label: "Fall Break",
      type: "HOLIDAY",
      startAt: "2024-10-11Z",
      endAt: "2024-10-14Z",
    },
    {
      label: "Teacher Work Day",
      type: "TEACHER_WORKDAY",
      startAt: "2023-10-25Z",
    },
    {
      label: "Voting Day",
      type: "HOLIDAY",
      startAt: "2024-11-05Z",
    },
    {
      label: "Thanksgiving Break",
      type: "HOLIDAY",
      startAt: "2024-11-25Z",
      endAt: "2024-11-29Z",
    },
    {
      label: "Winter Break",
      type: "HOLIDAY",
      startAt: "2024-12-23Z",
      endAt: "2025-01-03Z",
    },
    {
      label: "Teacher Work Day",
      type: "TEACHER_WORKDAY",
      startAt: "2025-01-06Z",
    },
    {
      label: "MLK Day",
      type: "HOLIDAY",
      startAt: "2025-01-20Z",
    },
    {
      label: "Teacher Work Day",
      type: "TEACHER_WORKDAY",
      startAt: "2025-02-07Z",
    },
    {
      label: "President's Day",
      type: "HOLIDAY",
      startAt: "2024-02-17Z",
    },
    {
      label: "Spring Break",
      type: "HOLIDAY",
      startAt: "2025-03-10Z",
      endAt: "2025-03-14Z",
    },
    {
      label: "Teacher Work Day",
      type: "TEACHER_WORKDAY",
      startAt: "2024-03-28Z",
    },
    {
      label: "Easter Holiday",
      type: "HOLIDAY",
      startAt: "2025-04-18Z",
      endAt: "2025-04-21Z",
    },
  ],
};
